import { categories } from "@/mocks/anime";

const tintMap: Record<string, string> = {
  "cat-1": "bg-primary-100 text-primary-700",
  "cat-2": "bg-accent-100 text-accent-700",
  "cat-3": "bg-secondary-100 text-secondary-700",
  "cat-4": "bg-primary-100 text-primary-700",
  "cat-5": "bg-accent-100 text-accent-700",
  "cat-6": "bg-secondary-100 text-secondary-700",
};

export default function Categories() {
  return (
    <section id="category" className="bg-background-100/70 py-14 md:py-20">
      <div className="mx-auto max-w-7xl px-4 md:px-6">
        <div className="text-center">
          <span className="inline-flex items-center gap-1.5 whitespace-nowrap rounded-full bg-secondary-100 px-3 py-1 text-xs font-medium text-secondary-700">
            <i className="ri-grid-fill"></i>
            番剧分类
          </span>
          <h2 className="mt-3 font-heading text-2xl md:text-4xl text-foreground-950">
            总有一款戳中你的萌点
          </h2>
          <p className="mx-auto mt-2 max-w-2xl text-sm md:text-base text-foreground-600">
            从动物拟人到兽耳萌番，从宠物日常到猫狗动画，六大主题任你挑选。
          </p>
        </div>

        <div className="mt-8 grid grid-cols-1 gap-4 sm:grid-cols-2 lg:grid-cols-3">
          {categories.map((c) => (
            <a
              key={c.id}
              href="#new"
              className="group flex flex-col rounded-2xl bg-background-50 border border-background-200/70 p-5 transition-all duration-300 hover:-translate-y-1 hover:border-primary-200"
            >
              <div className="flex items-center justify-between">
                <span
                  className={`flex h-12 w-12 items-center justify-center rounded-xl ${tintMap[c.id]} text-xl`}
                >
                  <i className={c.icon}></i>
                </span>
                <span className="whitespace-nowrap rounded-full bg-background-100 px-3 py-1 text-xs font-medium text-foreground-500">
                  {c.count} 部
                </span>
              </div>
              <h3 className="mt-4 font-heading text-lg text-foreground-950 group-hover:text-primary-700 transition-colors">
                {c.name}
              </h3>
              <p className="mt-0.5 text-xs uppercase tracking-wide text-foreground-400">{c.en}</p>
              <p className="mt-2 flex-1 text-sm text-foreground-600 leading-relaxed">{c.desc}</p>
              <span className="mt-4 inline-flex items-center gap-1 text-sm font-medium text-primary-600 group-hover:gap-2 transition-all">
                去逛逛
                <i className="ri-arrow-right-line text-sm"></i>
              </span>
            </a>
          ))}
        </div>
      </div>
    </section>
  );
}